import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import SchedulingGrid from '../components/SchedulingGrid';
import TutorBookingManagement from '../components/TutorBookingManagement';

const SchedulingPage: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <p className="text-gray-600">Please log in to access the scheduling system.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {user?.role === 'STUDENT' ? (
        <SchedulingGrid />
      ) : (
        <TutorBookingManagement />
      )}
    </div>
  );
};

export default SchedulingPage;